export default {

  bills: [],
  parts: [],
  loans: [],
  rewards: [],

};
